import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import moment from 'moment';

@Component({
  name: 'bpc-public-post-card',
  components: {},
})
export default class PublicPostCard extends Vue {
  @Prop(Object) readonly item: AnyEntity;

  onActionClicked(action, row) {
    this.$emit('action-clicked', action, row);
  }

  getContentIntro(content) {
    const div = document.createElement('div');
    div.innerHTML = content;
    let text = div.textContent || div.innerText || '';
    text = text
      .split(' ')
      .slice(0, 20)
      .join(' ');
    if (text != content) {
      text += ' [...]';
    }
    return text;
  }

  formatDate(date) {
    return moment(String(date)).format('DD/MM/YYYY');
  }

  currentImgField = 'defaultConversionUrl';
  imgFail = false;

  onImgError() {
    if (this.currentImgField === 'url') {
      this.imgFail = true;
    }
    if (this.currentImgField === 'defaultConversionUrl') {
      this.currentImgField = 'url';
    }
  }

  get imgUrl() {
    if (this.imgFail) {
      if (this.$store.getters['centerSettings/backgroundUrl']) {
        return this.$store.getters['centerSettings/backgroundUrl'];
      } else if (this.$store.getters['centerSettings/logoUrl']) {
        return this.$store.getters['centerSettings/logoUrl'];
      }
      return null;
    }

    return this.item.post_picture[this.currentImgField];
  }
  /* Lifecycle hooks */
  // created () { }
  // mounted () { }
  // updated () { }
  // destroyed () { }
}
